import { ITee } from '../../admin/courses/store';
import { IAdminFlight } from '../../admin/eventFlights/store';
import { IBaseEventRound } from '../../admin/eventRounds/store';
import { IClubSeason } from '../../admin/events/store';
import { IMetaFormat } from '../../admin/roundFormats/store';
import { IPlayer } from '../../user/store';
import { IClub } from '../clubs/store';

export type PlayerStatus = 'IN' | 'OUT' | 'TBD';

export interface IEventPlayer extends IPlayer {
  flight?: string;
  index?: string;
  status: PlayerStatus;
}

export interface IEventPrice {
  name: string;
  price: number;
  start: string;
  end: string;
  active?: boolean;
}

export interface IEventAddon {
  id: string;
  name: string;
  price: number;
}

export interface IEventsStore {
  all: {
    [id: number]: IEventItem;
  };
  [id: number]: IEventItem;
}

export interface IEventGroupGame {
  id: number;
  enrollment: IEventEnrollment;
  handicap: number;
  tee?: ITee;
}

export interface IEventGroup {
  id: string;
  order: number;
  round: string;
  start: string;
  enrollments: IEventEnrollment[];
  games: IEventGroupGame[];
}

export interface IEventTee {
  flight: number;
  id: number;
  round: number;
  tee: {
    id: number;
    name: string;
    par: number;
    rating: string;
    slope: number;
  };
}

export enum HOLES_CHOICES {
  HOLES_18 = 1,
  HOLES_9_FRONT = 2,
  HOLES_9_BACK = 3
}

export interface IEventRound extends IBaseEventRound {
  formats: IMetaFormat[];
  groups: IEventGroup[];
  teeAssigments: IEventTee[];
  title?: string;
}

export interface IEventRoundsStore {
  [roundId: string]: IEventRound;
}

export const eventStore: IEventsStore = { all: {} };

export const eventRoundsStore: IEventRoundsStore = {};

// TO BE DEFINE
// export type enrollmentStatus = 'active' | 'waiting' | 'canceled' | null;
export type enrollmentStatus = string;

export interface IEventEnrollment {
  event?: number;
  flight?: any;
  group?: any;
  handicap: string;
  id: number;
  index?: number;
  playerNote?: string;
  status: enrollmentStatus;
  team: number;
  tee?: string;
  user: IEventPlayer;
}

export interface IEventItem {
  addons: IEventAddon[];
  allowScramble: boolean;
  allowTeams: boolean;
  club: IClub;
  courses: string;
  created: string;
  days: number;
  description?: string;
  end: string;
  enrollment: IEventEnrollment;
  enrollments: IEventEnrollment[];
  firstTeeTime: string;
  flights: IAdminFlight[];
  flightsMetric: number;
  formats: IMetaFormat[];
  handicapMetric: number;
  id: number;
  image?: string;
  modified: string;
  name: string;
  price: IEventPrice;
  prices: IEventPrice[];
  processPayment: boolean;
  rounds: IEventRound[];
  season: IClubSeason;
  start: string;
  statusChanged: string;
  totalPlayers: number;
  totalRounds: number;
  useFlights: boolean;
}

export interface IEventRegistration {
  items: {
    addons: Array<{ id: number; event: number; name: string; price: string }>;
    clubMembershipPrice?: number;
    eventPrice: {
      id: number;
      name: string;
      start: string;
      end: string;
      ageFrom: string;
      ageTo: string;
      event: number;
      price: string;
    };
  };
  coupon:
    | {
        title: string;
        codename: string;
        discountValue: string;
      }
    | {};
  subtotalPrice: number;
  totalPrice: number;
}

export const eventRegistrationStore = {
  coupon: {},
  items: {
    addons: [],
    eventPrice: {
      ageFrom: '',
      ageTo: '',
      end: '',
      event: 0,
      id: 0,
      name: '',
      price: '',
      start: ''
    }
  },
  subtotalPrice: 0,
  totalPrice: 0
};
